import { gql } from '@apollo/client'

export const ADMIN_ACTIVATE_ACCOUNT_MUTATION = gql`
  mutation adminActivateAccount($input: AdminActivateAccountInput!) {
    adminActivateAccount(input: $input) {
      id 
      email
      activated_at
    }
  }
`